export default "__VITE_ASSET__o2IOe4O1__"